import { z } from "zod";

export const ValidationUpdateResponse = z.object({
    success: z.literal(false),
    message: z.literal("Validation errors"),
    code: z.literal(422),
    errors: z.object({
        name: z.array(z.string()),
        email: z.array(z.string()),
        username: z.array(z.string()),
        phone: z.array(z.string()),
    }),
});